import React from 'react';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCheckoutPause } from '../../PlatformConfig/store/selectors';
import { getCheckoutPauseMessage } from '../../PlatformConfig/utils/get-checkout-pause-message';
import styles from './CheckoutPauseBanner.module.css';

type CheckoutPauseBannerProps = {
  belowNavbar?: boolean;
};

export default function CheckoutPauseBanner({ belowNavbar = false }: CheckoutPauseBannerProps) {
  const { i18n } = useTranslation();
  const checkoutPause = useSelector(selectCheckoutPause);

  if (!checkoutPause?.enabled) {
    return null;
  }

  const message = getCheckoutPauseMessage(checkoutPause, i18n.language);
  const wrapperClassName = belowNavbar
    ? `${styles.wrapper} ${styles.wrapperBelowNavbar}`
    : styles.wrapper;

  return (
    <div className={wrapperClassName}>
      <Alert
        severity="warning"
        className={styles.alert}
        classes={{ icon: styles.icon, message: styles.message }}
      >
        {message}
      </Alert>
    </div>
  );
}
